import i18n from "i18next"
import { MESSAGE_CODE_NO_SUBSCRIPTION_PLAN, salesMessageCodeMap } from "modules/messageCodeSales"
import { all, call, fork, put, select, takeEvery } from "redux-saga/effects"
import * as fetchApi from "services/api/fetchApi"
import { globalUiAction } from "services/globalUi"

import { contractAction } from "./action"
import { initialState } from "./reducer"
import { getContract } from "./selector"

function* fetchContractList({ payload }) {
  const contract = yield select(getContract)

  try {
    yield put(globalUiAction.setGlobalUI({ isLoading: true }))
    yield put(contractAction.setContractState(initialState))
    const response = yield call(fetchApi.postDataByFetch, payload.url, payload.postData, {
      headers: { "Accept-Language": i18n.language },
    })

    if (response.data.Result === 1) {
      yield put(
        contractAction.setContractState({
          signState: payload.nextState ? payload.nextState : contract.signState,
          signLists: response.data.Data,
        }),
      )
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: response.data.MessageCode,
        message: response.data.Message,
      }
    }
  } catch (error) {
    yield put(
      globalUiAction.openErrorModal({
        title: "fetch contract list error",
        content: `${error.name}, ${error.message}`,
      }),
    )
  } finally {
    yield put(globalUiAction.setGlobalUI({ isLoading: false }))
  }
}

function* fetchALLContract({ payload }) {
  const contract = yield select(getContract)
  const firstContract = yield contract.signLists.Contracts.find((obj) => obj.Seq === 1)
  const otherContracts = yield all(contract.signLists.Contracts.filter((obj) => obj.Seq !== 1))

  try {
    yield put(globalUiAction.setGlobalUI({ isLoading: true }))
    const firstResponse = yield call(
      fetchApi.postDataByFetch,
      payload.url,
      {
        AttachType: firstContract.AttachType,
        SignType: contract.signLists.SignType,
        ...payload.postParameter,
      },
      { headers: { "Accept-Language": i18n.language } },
    )

    if (firstResponse.data.Result === 1) {
      const contractArr = [
        {
          ContractId: firstResponse.data.Data.ContractId,
          SignFileUrl: firstResponse.data.Data.SignFileUrl,
          SignTabList: firstResponse.data.Data.SignTabList,
          AttachType: firstContract.AttachType,
        },
      ]

      yield put(
        contractAction.setContractState({
          allContract: contractArr,
        }),
      )
      yield put(
        contractAction.setContractState({
          signState: payload.nextState ? payload.nextState : contract.signState,
        }),
      )

      // fetch more contracts
      if (otherContracts.length) {
        const otherResponse = yield all(
          otherContracts.map((obj) =>
            call(
              fetchApi.postDataByFetch,
              payload.url,
              {
                AttachType: obj.AttachType,
                SignType: contract.signLists.SignType,
                ...payload.postParameter,
              },
              { headers: { "Accept-Language": i18n.language } },
            ),
          ),
        )

        const newSignatureData = yield all(
          otherResponse.reduce(
            (arr, currentRes, index) => {
              if (currentRes.data.Result === 1) {
                return [
                  {
                    SignFileUrl: currentRes.data.Data.SignFileUrl,
                    SignTabList: currentRes.data.Data.SignTabList,
                    AttachType: otherContracts[index].AttachType,
                  },
                  ...arr,
                ]
              } else {
                throw {
                  // eslint-disable-line no-throw-literal
                  name: currentRes.data.MessageCode,
                  message: currentRes.data.Message,
                }
              }
            },
            [...contractArr],
          ),
        )

        yield put(contractAction.setContractState({ allContract: newSignatureData }))
      }
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: firstResponse.data.MessageCode,
        message: firstResponse.data.Message,
      }
    }
  } catch (error) {
    if (error.name === String(MESSAGE_CODE_NO_SUBSCRIPTION_PLAN)) {
      yield put(
        globalUiAction.openWarningModal({
          name: i18n.t("sales:message.dialog.title.contract_signing"),
          title: i18n.t("sales:message.dialog.title.tariff_plan_not_selected"),
          content: i18n.t("sales:message.dialog.content.tariff_plan_not_selected"),
        }),
      )
    } else {
      const errorCode = salesMessageCodeMap.get(parseInt(10000, 10)) ?? "system_is_busy"
      yield put(
        globalUiAction.openErrorModal({
          title: i18n.t("label:error"),
          content: i18n.t(`sales:message.${errorCode}`),
        }),
      )
    }
  } finally {
    yield put(globalUiAction.setGlobalUI({ isLoading: false }))
  }
}
//=====================================
//  WATCHERS
//-------------------------------------

export function* watchFetchContractList() {
  yield takeEvery(contractAction.FETCH_CONTRACT_LIST, fetchContractList)
}

export function* watchFetchALLContract() {
  yield takeEvery(contractAction.FETCH_ALL_CONTRACT, fetchALLContract)
}
//=====================================
//  ROOT
//-------------------------------------

export const contractSaga = [fork(watchFetchContractList), fork(watchFetchALLContract)]
